/* Customization:
  - Added title block
  - Added bg selector color
  - Added description sortable and inverted table
*/

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  titleBlock: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  bgColor: {
    id: 'Colore di sfondo',
    defaultMessage: 'Colore di sfondo',
  },
  hideHeaders: {
    id: 'Hide headers',
    defaultMessage: 'Hide headers',
  },
  sortable: {
    id: 'Make the table sortable',
    defaultMessage: 'Make the table sortable',
  },
  sortableDescription: {
    id: 'Visible only in view mode',
    defaultMessage: 'Visible only in view mode',
  },
  fixed: {
    id: 'Fixed width table cells',
    defaultMessage: 'Fixed width table cells',
  },
  compact: {
    id: 'Make the table compact',
    defaultMessage: 'Make the table compact',
  },
  basic: {
    id: 'Reduce complexity',
    defaultMessage: 'Reduce complexity',
  },
  celled: {
    id: 'Divide each row into separate cells',
    defaultMessage: 'Divide each row into separate cells',
  },
  inverted: {
    id: 'Table color inverted',
    defaultMessage: 'Table color inverted',
  },
  invertedDescription: {
    id: 'Recommended when the table background is dark color',
    defaultMessage: 'Recommended when the table background is dark color',
  },
  striped: {
    id: 'Stripe alternate rows with color',
    defaultMessage: 'Stripe alternate rows with color',
  },
});

function TableSchema(props) {
  const { intl } = props;
  return {
    title: 'Table block',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'title',
          'bg',
          'hideHeaders',
          'sortable',
          'fixed',
          'celled',
          'striped',
          'compact',
          'basic',
          'inverted',
        ],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.titleBlock),
      },
      bg: {
        widget: 'select',
        title: intl.formatMessage(messages.bgColor),
        default: 'none',
        choices: [
          ['none', 'Nessuno'],
          ['light', 'Grigio chiaro'],
          ['subsite-primary-light', 'Di accento chiaro'],
          ['primary', 'Primario'],
        ],
      },
      hideHeaders: {
        title: intl.formatMessage(messages.hideHeaders),
        type: 'boolean',
      },
      sortable: {
        title: intl.formatMessage(messages.sortable),
        type: 'boolean',
        description: intl.formatMessage(messages.sortableDescription),
      },
      fixed: {
        title: intl.formatMessage(messages.fixed),
        type: 'boolean',
      },
      celled: {
        title: intl.formatMessage(messages.celled),
        type: 'boolean',
      },
      striped: {
        title: intl.formatMessage(messages.striped),
        type: 'boolean',
      },
      compact: {
        title: intl.formatMessage(messages.compact),
        type: 'boolean',
      },
      basic: {
        title: intl.formatMessage(messages.basic),
        type: 'boolean',
      },
      inverted: {
        title: intl.formatMessage(messages.inverted),
        type: 'boolean',
        description: intl.formatMessage(messages.invertedDescription),
      },
    },
    required: [],
  };
}

export function TableBlockSchema(props) {
  return {
    title: 'Table block',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['table'],
      },
    ],
    properties: {
      table: {
        title: 'Table block',
        widget: 'object',
        schema: TableSchema(props),
      },
    },

    required: [],
  };
}

export default TableBlockSchema;
